import React from 'react';
import logo from './logo.svg';
import './App.css';
import Card from './cardcomponents/Card';
import Contact from './Contact/Contact';
import Image from './Image/Image';
import End from './Endtext.tsx/End';
import Whats from './Svg/Whats';
import Images from './Pic/Images';
import Vcard from './Vcard/Vcard';
import Call from './Call-t/Call';
import Tss from './Ht/Tss';
import Story from './Ht/Story';
import InstagramStories from './Insta/InstagramStories';
import Welcome from './Welcome screen/Welcome';
import Savbu from './SavButon/Savbu';
import Lang from './Lang/Lang';
import AccessibilityScript from './Accessibility';
function App() {
  return (
    <div className="App">
      <Card />
      <Contact />
      <Image />
      <AccessibilityScript />
      <Whats />
      <Welcome />

    </div>
  );
}

export default App;
